import ErrorBoundary from 'components/ErrorBoundary'
import { PropsWithChildren, Suspense } from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'

function LazyComponent({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
    </ErrorBoundary>
  )
}

export default LazyComponent
